export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-primary-500 mb-4">古古漫画网</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费全集下拉式阅读日漫韩漫国漫大全，好看的漫画免费在线看全集。每日更新，高清无广告。百万漫迷的共同选择。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">人气榜单</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">分类索引</a>
              <a href="#updates" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">更新快报</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门话题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h3>
            <div className="flex flex-col gap-2">
              <a href="#about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">平台介绍</a>
              <a href="#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">投稿联系</a>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">常见答疑</a>
              <a href="#app" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">客户端下载</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              暂无合作伙伴链接
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-xs text-foreground-500">
            <span>&copy; 2018 - {new Date().getFullYear()} 古古漫画网</span>
            <span className="hidden sm:block text-foreground-300">|</span>
            <span>本站所有漫画均来自网络，版权归原作者所有</span>
          </div>
          <a
            href="#hero"
            className="inline-flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}